
import * as R from 'ramda'
import { call, reducer } from '../../../helpers/api/meta'
import { getCourseThread } from '../../../helpers/api/api';

export const GET_COURSE_THREAD = 'GET_COURSE_THREAD'

export const callGetCourseThread = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseThread(params),
        inputs,
        action: GET_COURSE_THREAD,
        messages: {
            id: 'getCourseThread',
            failure: 'Could not get course thread'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    results: []
}

const saveCourseThread = (state, action) => {
    return R.assoc('results', action.results, state);
}

const messages = {
    loadFailed: 'Could not load thread.',
}

export default reducer(initialState, GET_COURSE_THREAD, saveCourseThread, messages.loadFailed)